var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user !== null)?_c('v-avatar',{style:({'background-color': _vm.backgroundColor}),attrs:{"size":_vm.size}},[_c('strong',{staticClass:"initials",class:{
        shadow: !_vm.initialsOnly,
      },staticStyle:{"margin-left":"1px"},style:({
        color: _vm.fontColor,
        'font-size': _vm.fontSize,
      })},[_vm._v(_vm._s(_vm.firstNameInitial + _vm.lastNameInitial || '?'))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UserManagement/UserInitials.vue?vue&type=template&id=1ccfc294&scoped=true&
// module id = 2737
// module chunks = 5